"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var Icon_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/icon/Icon"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var actions_1 = require("../../../redux/reducers/authentication/actions");
var framework_1 = require("../../../widgets/framework");
var ResendActivationDialog_1 = __importDefault(require("../../LoginWidget/components/resend-activation/ResendActivationDialog"));
var ResendActivationEmailSentDialog_1 = __importDefault(require("../../LoginWidget/components/resend-activation/ResendActivationEmailSentDialog"));
var styles_1 = __importDefault(require("../styles"));
var Confirmation = function (_a) {
    var navigateToLogin = _a.navigateToLogin;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), resendMailSent = _b.resendMailSent, emailAddress = _b.emailAddress;
    var _c = react_1.default.useState(false), showResendDialog = _c[0], setShowResendDialog = _c[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var redirectToLogin = function () {
        framework_1.GoFwInternalInstance.onHostLogin();
    };
    var navigateResendLink = function () {
        setShowResendDialog(true);
    };
    var closeResendActivationDialog = function () {
        setShowResendDialog(false);
    };
    var closeEmailSentDialog = function () {
        dispatch((0, actions_1.resetResendMail)());
        redirectToLogin();
    };
    return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, container: true, alignItems: "center", justifyContent: "center", direction: "column" },
        react_1.default.createElement(Icon_1.default, { iconType: "custom", iconName: "icon-mail", className: classes.confirmIcon, color: "primary" }),
        react_1.default.createElement(core_1.Typography, { variant: 'body1', align: 'center', style: { marginBottom: theme.spacing(3), fontSize: '16px' } }, "We have sent you an email confirmation"),
        react_1.default.createElement(core_1.Typography, { variant: 'body1', color: 'textPrimary', align: 'center', style: { fontWeight: 'bold', marginBottom: theme.spacing(3), fontSize: '16px' } }, "Activate your account within 30 minutes of receiving the email"),
        react_1.default.createElement(core_1.Typography, { variant: 'body1', align: 'center', style: { fontSize: '16px' } }, "If you haven't received the email"),
        react_1.default.createElement(core_1.Button, { variant: 'text', color: 'primary', onClick: navigateResendLink, className: classes.textButton }, "click here to re-send activation"),
        react_1.default.createElement(core_1.Button, { variant: 'contained', color: 'primary', onClick: navigateToLogin, style: { padding: '12px 24px !important' } }, "Sign In"),
        react_1.default.createElement(ResendActivationDialog_1.default, { show: showResendDialog, onSuccessCallback: closeResendActivationDialog, closeReactivationDialog: closeResendActivationDialog }),
        react_1.default.createElement(ResendActivationEmailSentDialog_1.default, { show: resendMailSent, email: emailAddress, okayCallback: closeEmailSentDialog })));
};
exports.default = Confirmation;
//# sourceMappingURL=Confirmation.js.map